import { ResourcesPanel } from '../resources-panel/ResourcesPanel';

export const LeftSidebar = () => {
  return (
    <div className="left-sidebar">
      <ResourcesPanel />
    </div>
  );
};
